// extracted by mini-css-extract-plugin
export default {"heading":"DeleteModal_heading__HfFKZ"};